<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-accident-report`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M27.455 5.954a4 4 0 00-6.91 0L2.548 35.984A4 4 0 006.003 42h35.993a4 4 0 003.455-6.016L27.455 5.954zM6.003 38L24 7.97 41.996 38H6.003zm18.747-6c.76 0 1.375.615 1.375 1.375v1.375c0 .76-.616 1.375-1.375 1.375h-1.375c-.76 0-1.375-.616-1.375-1.375v-1.375c0-.76.616-1.375 1.375-1.375h1.375zm1.259-15.002a1 1 0 00-1-1h-2.002a1 1 0 00-1 1v12a1 1 0 001 1h2.002a1 1 0 001-1v-12z"/></svg>
</template>
<script>

export default {
  name: 'IconAccidentReport',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
